import React, { memo, useCallback } from 'react'
import type { Image } from './types'
import { getImageUrl } from './get-image-url'
import { BgPictureContainer, ThumbnailContainer, ThumbnailImage } from './styles'

interface ThumbnailImageComponentProps {
    image: Image
    handleImageClick: (index: number) => void
    index: number
    imageBorder?: string
    imageBorderRadius?: string
}

const ThumbnailImageComponent: React.FC<ThumbnailImageComponentProps> = ({
    image,
    handleImageClick,
    index,
    imageBorder,
    imageBorderRadius,
}) => {
    const imageUrls = {
        small: getImageUrl('small-mobile', image),
        medium: getImageUrl('medium-mobile', image),
        large: getImageUrl('large-mobile', image),
        desktop: getImageUrl('desktop', image),
        wideScreen: getImageUrl('wide-screen', image),
    }

    const handleClick = useCallback(() => {
        handleImageClick(index)
    }, [index, handleImageClick])

    return (
        <ThumbnailContainer onClick={handleClick} imageBorder={imageBorder} imageBorderRadius={imageBorderRadius}>
            <BgPictureContainer>
                {imageUrls.large && <source media="(min-width:480px)" srcSet={imageUrls.large} />}
                {imageUrls.medium && <source media="(min-width:320px)" srcSet={imageUrls.medium} />}
                {imageUrls.small && (
                    <ThumbnailImage
                        alt={image.caption}
                        src={imageUrls.small}
                        imageBorder={imageBorder}
                        imageBorderRadius={imageBorderRadius}
                        loading="lazy"
                        decoding="async"
                    />
                )}
            </BgPictureContainer>
        </ThumbnailContainer>
    )
}

export default memo(ThumbnailImageComponent)
